import fromPairs from 'lodash/fromPairs'

// handles errors payloads created with api_error! @ back
export class APIError extends Error {
  constructor(errorPayload, httpStatus) {
    const payload =
      errorPayload && typeof errorPayload === 'object' ? errorPayload : {}
    super(payload.message)
    this.name = 'APIError'
    this.data = payload.data
    // A body that already names a status wins. Otherwise keep the HTTP status,
    // so a bare `not_found` payload is still a 404.
    this.status = payload.status ?? httpStatus
  }

  asObject() {
    return fromPairs((this.data || []).map(errKey => [errKey, true]))
  }
}

export default APIError
